<div class="rfr_input-wrapper">
  <ion-item>
    <ion-label [position]="labelPosition">{{ labelText }}</ion-label>
    <ion-input
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [value]="value"
      (ionChange)="onInputChange($event)"
      (ionBlur)="onTouched()"
    ></ion-input>
  </ion-item>
</div>